import { render, staticRenderFns } from "./LegalLinks.vue?vue&type=template&id=7cd010ff&scoped=true"
import script from "./LegalLinks.vue?vue&type=script&lang=js"
export * from "./LegalLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd010ff",
  null
  
)

export default component.exports